import { RootState } from 'stores/congifure-store';
import firebase from 'firebase/app';
import 'firebase/auth';

export const selectUserId = (state: RootState): string | undefined => state.User.user?.uid;
export const selectCurrentUser = (state: RootState): firebase.User | undefined => state.User.user;
export const selectCustomerIsSubscriber = (state: RootState): boolean | undefined => state.User.subscriber;
export const selectUserQuickWinAccomplished = (state: RootState): boolean | undefined =>
  state.User.quickWinAccomplished;
